import { hasVariant, isFeatureActive } from '../../selectors/configSelectors';
import { MVT_1164 } from '../../flags/experiments';
import { CO_HOMEPAGE_REDIRECT_TO_HOME } from '../../flags/features';

const isRedirectToHomeActive = (state) =>
  hasVariant(state, MVT_1164, 'on') ||
  hasVariant(state, MVT_1164, 'no_holdout') ||
  isFeatureActive(state, CO_HOMEPAGE_REDIRECT_TO_HOME);

export default isRedirectToHomeActive;
